import { ref } from 'vue'
import axios from 'axios'
import qs from 'qs'

export const useSubmitForm = (submitFormUrl, thanksPageUrl, formParamKey, authenticityToken) => {
  const isProcessing = ref(false) // 二重送信防止用のフラグ

  const submitParams = (formParam) => {
    const requestBody = {
      [formParamKey]: formParam,
      authenticity_token: authenticityToken
    }

    return qs.stringify(
      requestBody,
      { arrayFormat: 'brackets' }
    )
  }

  const submitForm = async(formParam) => {
    // 二重送信防止用のフラグが立っていたら、送信しない。
    if (isProcessing.value) { return false }
    isProcessing.value = true

    axios.post(submitFormUrl, submitParams(formParam))
      .then((response) => {
        if (response.data && response.status === 200) {
          // thanksページに遷移させる
          location.href = thanksPageUrl
          return;
        }
      })
      .catch((error) => {
        alert("予想外のエラーが発生しました。\nお手数ですが再度画面を読み込んだ上で、操作をやり直してください。")
        isProcessing.value = false;
      })
  }

  return { submitForm }
}
